// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const REVIEW_SECTION_OFFER = "Ponuka";
export const SEO_TITLE_STROLLER_COMPONENT_DETAILED_REVIEW = "Podrobn\u00e1 recenzia";
export const SEO_TITLE_STROLLER_COMPONENT_FORUM = "Ot\u00e1zky/porad\u0148a";
export const SEO_TITLE_STROLLER_COMPONENT_REVIEWS = "Hodnotenia";
export const SEO_TITLE_STROLLER_COMPONENT_VIDEO = "Video";
export const STROLLER_CARD_COMPARE = "Porovnaj";
export const STROLLER_CARD_COMPARE_REMOVE = "Odober";
export const STROLLER_DETAIL_ADD_TO_PROFILE = "Pridaj do v\u00fdbavi\u010dky";
export const STROLLER_DETAIL_REMOVE_FROM_PROFILE = "Zma\u017e z v\u00fdbavi\u010dky";
export const STROLLER_DETAIL_SEAERCH_STROLLER = "H\u013eadaj ko\u010d\u00edk";
